import { useEffect } from 'react';

import { Sport } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useSportContext } from 'contexts/sport';
import useLifecycle, { LIFECYCLE } from 'hooks/useLifecycle';
import useLocalStorage, { STORAGE } from 'hooks/useLocalStorage';

const StoreLastVisitedSport = () => {
  const { sport } = useSportContext();
  const { currentUser } = useCurrentUserContext();
  const { update: storeLastVisitedSport, lifecycle } = useLifecycle();
  const lastVisitedSport = lifecycle?.lastVisitedSport;

  const [lastVisitedSportStorage, storeLastVisitedSportStorage] =
    useLocalStorage<Sport | undefined>(STORAGE.lastVisitedSport, undefined);

  useEffect(() => {
    if (currentUser?.slug && sport !== lastVisitedSport) {
      storeLastVisitedSport(LIFECYCLE.lastVisitedSport, sport);
    }
  }, [currentUser?.slug, lastVisitedSport, sport, storeLastVisitedSport]);

  useEffect(() => {
    if (lastVisitedSportStorage !== sport) {
      storeLastVisitedSportStorage(sport);
    }
  }, [lastVisitedSportStorage, sport, storeLastVisitedSportStorage]);

  return null;
};

export default StoreLastVisitedSport;
